module.exports = __webpack_public_path__ + "static/media/train4.9c8f7526.png";